export default {

    /**
     * Delete all of the passed in forms
     * @param ids
     */
    destroy: function(ids) {
        return $.ajax({
            type: "DELETE",
            contentType: "application/json",
            url: context.path + "/webservices/rest/form/designer/delete",
            data: JSON.stringify(ids)
        });
    },

    unlockForm: function(id) {
        return $.ajax({
            type: "POST",
            url: context.path + "/webservices/rest/form/designer/unlock/" + id
        });
    },

    /** Deactivate a form.
     *
     * @param form Form to deactivate
     */
    deactivateForm: function(form) {
        return $.ajax({
            type: "POST",
            url: context.path + "/webservices/rest/form/designer/deactivate/" + form.id
        });
    },

    /**
     * Active the form.
     * @param form Form to activate
     */
    activateForm: function(form) {
        return $.ajax({
            type: "POST",
            url: context.path + "/webservices/rest/form/designer/activate/" + form.id
        });
    },

    /**
     * Get the latest version of the form with the given name. Gets the active version if there is one.
     * Otherwise gets the working copy with the given name.
     * @param formName the name of the form to get a version of
     * @returns {*}
     */
    getLatestByName: function(formName) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/designer/latest",
            contentType: "application/json",
            method: "GET",
            data: {
                name: formName
            }
        });
    },

    /**
     * Get the form instance associated with the given documentId, for a form document. Takes a VIEW or EDIT mode,
     * and checks document security permissions on the document as well, erroring if the current user does not have
     * appropriate permissions.
     *
     * @param docId the documentId to get the form instance for
     * @param mode VIEW or EDIT mode
     * @returns {*} SavedFormModel form instance object
     */
    getFormDocument: function(docId, mode) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/document/" + mode.toLowerCase() + "/" + docId,
            contentType: "application/json",
            method: "GET"
        });
    },

    /**
     * Get the form instance associated with the given form instance ID, when the ID is all you have (ie URL API call).
     *
     * @param formInstanceId the ID of the form instance to get the complete form instance object for
     * @returns {*} SavedFormModel form instance object
     */
    getFormInstance: function(formInstanceId) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/instance/" + formInstanceId,
            contentType: "application/json",
            method: "GET"
        });
    },

    /**
     * Validate the passed controls, using the form data passed in the displayed form.
     * @param form the displayed form, with formData
     * @param controls an array of the names of the form controls to validate
     */
    validateForm: function(form, controls) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/instance/validate",
            contentType: "application/json",
            method: "POST",
            data: JSON.stringify({
                instance: form,
                controlNames: controls
            })
        });
    },

    /**
     * Submit a form instance, along with all its data.
     * @param form SavedFormModel including all user-entered data to save
     */
    submitForm: function(form) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/submit",
            contentType: "application/json",
            method: "POST",
            data: JSON.stringify(form)
        });
    },

    /**
     * Render the form, bringing back everything needed to draw it.
     * @param form Form should include EITHER: id, formId, or formName. They are checked on the server, in that order.
     * SavedFormModel can be used to construct a valid object to pass here.
     * @param mode VIEW or EDIT
     * @param sessionId form session id
     */
    renderForm: function(form, mode, sessionId) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/render",
            contentType: "application/json",
            method: "POST",
            data: JSON.stringify({
                mode: mode,
                formName: form.formName,
                id: form.formId ? form.formId : undefined,
                instanceId: form.id ? form.id : undefined,
                formSessionId: sessionId,
                data: form.formData
            })
        });
    },

    /**
     * Resolve parameters from the URL API, using server's knowledge of which form
     * controls can accept mulitple values. Server will deal appropriately with delimiters in the URL
     * API values (ie comma by default).
     * @param data
     * @returns {*}
     */
    getFormUrlApiParams: function(data) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/urlapi/params",
            contentType: "application/json",
            method: "POST",
            data: JSON.stringify(data)
        });
    },

    /**
     * Remove a file that has been uploaded from an eform but not yet saved as part of the form instance.
     * @param id
     * @return {*}
     */
    removeTempUpload: function(id) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/upload/temp/remove/" + id,
            contentType: "application/json",
            method: "POST"
        });
    },

    /**
     * Removes the form from the gateway
     * @param [formInstanceId] {string} Required when deleting a gateway form instance
     * @param [formName] {string} Required when deleting a loaded form state
     * @param [gatewayPageId] {string} Required when deleting a loaded form state
     * @returns {*}
     */
    deleteGatewayMapping: function(formInstanceId, formName, gatewayPageId) {
        return $.ajax({
            url: context.path + "/webservices/rest/form/gatewayFormMapping",
            contentType: "application/json",
            method: "DELETE",
            data: JSON.stringify({
                formInstanceId: formInstanceId,
                formName: formName,
                gatewayPageId: gatewayPageId
            })
        });
    }
};
